const shouldBeArray = function (data) {
  if (Array.isArray(data))
    return data;

  return typeof data === 'object' ? Object.values(data) : [];
}

const bodyScroll = (hide, mobilesOnly) => {
  const BODY_NO_SCROLL_CLASS = 'no-scroll';
  const BODY_NO_SCROLL_MOBILE_CLASS = 'no-scroll-mobile';
  const bodyClassList = document.querySelector('body').classList
  const className = mobilesOnly ? BODY_NO_SCROLL_MOBILE_CLASS : BODY_NO_SCROLL_CLASS
  if (hide) {
    bodyClassList.add(className)
  } else {
    bodyClassList.remove(className)
  }
  return true
}

export const hideBodyScroll = (mobilesOnly = false) => bodyScroll(true, mobilesOnly)

export const showBodyScroll = (mobilesOnly = false) => bodyScroll(false, mobilesOnly)

export {
  shouldBeArray
}
